import React from 'react';
import { Box } from 'rebass/styled-components';

import { layout } from '../../../../constants/constants';
import { LowImpactNarrowHeroContent } from '../../../models/app-data-model';
import Breadcrumbs from '../../bread-crumbs/breadcrumbs';
import './low-impact-narrow.scss';
import { corewellHeroOverrideClasses } from '../../../../constants/constants';
import { Media } from '../../../contexts/media/MediaContext';

export type HeroContentProps = {
  heroContent: LowImpactNarrowHeroContent;
  corewellStyleOverrides?: boolean;
};

const HeroLowImpactNarrow: React.FC<HeroContentProps> = ({ heroContent, corewellStyleOverrides }: HeroContentProps) => {

  const corewellClassOverrides = corewellStyleOverrides ? `${corewellHeroOverrideClasses?.mediumImpactHeroHeadingOverride}` : '';
  const titleClass = `title ${corewellClassOverrides}`;

  return (
    <Box
      className="low-impact-narrow"
      data-testid={`low-impact-narrow${heroContent.padding_bottom ? '-additional-padding' : ''}`}
      width={layout.singleColWidth}
      marginX={'auto'}
      px={layout.pagePaddingX}
      pt={7}
      pb={heroContent.padding_bottom ? 7 : 3}
    >
      <div className="breadcrumbs-container">
        
        {heroContent?.breadcrumbs?.subsite && 
        <Media greaterThanOrEqual="desktop" className="desktop-image-container">
          <Breadcrumbs breadcrumbsContent={heroContent.breadcrumbs}></Breadcrumbs>
        </Media>
        
        }
      </div>
      <h1 className={`xl-6 ${titleClass}`}>{heroContent.header}</h1>
    </Box>
  );
};

export default HeroLowImpactNarrow;
